export const chargingTimes = [...Array(24).keys()].map((hourIdx) => ({
  id: hourIdx,
  translationKey: `chargingWindows.chargingTimes.${hourIdx}`,
}));

export const somethingElse = 'asdfa';
